export const VCA_CERTIFICATE_TYPE = 'vca'
